import { render, staticRenderFns } from "./xiabiao.vue?vue&type=template&id=476a4948&scoped=true&"
import script from "./xiabiao.vue?vue&type=script&lang=js&"
export * from "./xiabiao.vue?vue&type=script&lang=js&"
import style0 from "./xiabiao.vue?vue&type=style&index=0&id=476a4948&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "476a4948",
  null
  
)

export default component.exports